// extracted by mini-css-extract-plugin
module.exports = {"--typer-animation":"designed-typer_--typer-animation__Xw2kU","typer-animation":"designed-typer_typer-animation__sPZvj"};